var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPanelIllustration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_ic_panel_illustration)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 23.52H2.25C1.27 23.52 0.48 22.73 0.48 21.75V2.24998C0.48 1.26998 1.27 0.47998 2.25 0.47998H12V1.01998H2.25C1.57 1.01998 1.02 1.56998 1.02 2.24998V21.75C1.02 22.43 1.57 22.98 2.25 22.98H21.75C22.43 22.98 22.98 22.43 22.98 21.75V12H23.52V21.75C23.52 22.73 22.73 23.52 21.75 23.52ZM18.75 19.02H5.25C5.1 19.02 4.98 18.9 4.98 18.75V5.24998C4.98 5.09998 5.1 4.97998 5.25 4.97998H12C12.15 4.97998 12.27 5.09998 12.27 5.24998V11.73H18.75C18.9 11.73 19.02 11.85 19.02 12V18.75C19.02 18.9 18.9 19.02 18.75 19.02ZM12.27 18.48H18.48V12.27H12.27V18.48ZM5.52 18.48H11.73V12.27H5.52V18.48ZM5.52 11.73H11.73V5.51998H5.52V11.73ZM23.25 7.76998H16.5C16.35 7.76998 16.23 7.64998 16.23 7.49998V0.74998C16.23 0.59998 16.35 0.47998 16.5 0.47998H23.25C23.4 0.47998 23.52 0.59998 23.52 0.74998V7.49998C23.52 7.64998 23.4 7.76998 23.25 7.76998ZM16.77 7.22998H22.98V1.01998H16.77V7.22998Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.98 1.01998H16.77V7.22998H22.98V1.01998Z",
    fill: "#7CE9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.73 5.51998H5.52V11.73H11.73V5.51998Z",
    fill: "#D3F8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.73 12.27H5.52V18.48H11.73V12.27Z",
    fill: "#D3F8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.48 12.27H12.27V18.48H18.48V12.27Z",
    fill: "#D3F8F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_ic_panel_illustration"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPanelIllustration);
export default __webpack_public_path__ + "static/media/ic-panel-illustration.de0ebe5ca5046731dfcf735cc4df9743.svg";
export { ForwardRef as ReactComponent };